import { createFileRoute } from "@tanstack/react-router";
import IrrigationSystemEditor from "@/components/field/setup/IrrigationSystemEditor";

export const Route = createFileRoute(
    "/dashboard/fields/$fieldId/setup/irrigation-system/new",
)({
    component: IrrigationSystemNewPane,
});

function IrrigationSystemNewPane() {
    return <IrrigationSystemEditor />;
}
